export const isPercentageValueType = (valueType?: string | null): boolean =>
  valueType === 'Percentage';

/** Convert stored threshold value to form display (e.g. 0.02 → 2 for Percentage). */
export const toDisplayThresholdValue = (
  value: number | null | undefined,
  valueType?: string | null
): number | undefined => {
  if (value == null) return undefined;
  return isPercentageValueType(valueType) ? value * 100 : value;
};

/** Convert form display value to stored threshold value (e.g. 2 → 0.02 for Percentage). */
export const toStorageThresholdValue = (
  value: number | null | undefined,
  valueType?: string | null
): number | null => {
  if (value == null || Number.isNaN(value)) return null;
  return isPercentageValueType(valueType) ? value / 100 : value;
};

export const formatThresholdBound = (
  value?: number | null,
  valueType?: string | null
): string => {
  if (value === undefined || value === null) return '—';

  switch (valueType) {
    case 'Percentage':
      return `${(value * 100).toFixed(1)}%`;
    case 'Ratio':
      return value.toString();
    case 'Ratings':
      return `${value} ★`;
    case 'Amount':
      return `${value} ₹`;
    case 'UOM':
    default:
      return value.toString();
  }
};
